<template>
    <div class="fshr-loadMoreContainer">
        <slot name="main" v-bind:items="items">

        </slot>
        <div class="fshr-loadMoreContainer--button" v-if="has_next">
          <button
              class="
                fshr-button
                fshr-button--center
                fshr-button--commonImportance
                fshr-button--big
                fshr-button--iconed
                fshr-icon fshr-icon--littleArrowDown
                fshr-widerButton
                fshr-shadowedButton
                "
              :class="loadingClass"
              @click="loadData"
          >{{getTranslation('nacist_vice')}}</button>
        </div>
        <div class="fshr-tabsSubtitle" v-else>
          <strong>{{getTranslation('toto_je_prozatim_vsechno')}}</strong>
        </div>
    </div>
</template>

<script>
    import axios from "axios";

    export default {
        name: "LoadMore",
        data: function () {
            return {
                page: 0,
                items: [],
                loading: false,
                delay: 200,
                has_next: true,
            }
        },
        mounted() {
          this.items = this.default_data;
        },
        computed: {
            loadingClass: function () {
              if(this.loading){
                return [ 'fshr-isWorking','fshr-button--disabled'];
              }
              return [];
            }
        },
        methods:{
          loadData: function () {

            this.page++;
            this.loading = true;
            let getUrl = this.updateURLParameter(this.api_url, "count", this.more_offset);
            getUrl = this.updateURLParameter(getUrl, "page", this.page);

            setTimeout(()=>{
              axios.get(getUrl).then( (response) => {
                if (response.status === 200) {
                  if (response.data.status === 1) {
                    this.items = this.items.concat(response.data.payload);
                    if(!response.data.has_next){
                      this.has_next = false;
                    }
                  }
                } else {
                  console.error("Error in connection to server");
                  console.error(response.statusText);
                }
                this.loading = false;
              }).catch(function (error) {
                console.error("Error in fetching data");
                console.error(error);
                this.loading = false;
              });
            }, this.delay);

          }
        },
        props: {
            api_url: {
                required: false,
                default: "/JSON/loadmore_resorts.json",
                type: String
            },
            default_data: {
                required: false,
                default: function () {
                    return []
                },
                type: Array
            },
            more_offset: {
                required: false,
                default: 4,
                type: Number
            },
            translations: {
                default: function () {
                    return {
                        "nacist_vice": "Načíst více",
                        "toto_je_prozatim_vsechno": "Toto je prozatím všechno"
                    }
                },
                required: false,
                type: Object
            }
        }
    }
</script>

<style scoped>
  .fshr-loadMoreContainer--button{
    margin-top: 20px;
  }
</style>
